<template>
  <div class="container-fluid h-100">
    <div 
      class="content-catalogue" 
      id="content-catalogue-id" 
      title="Catálogo Havoline MotoClub" 
      alt="Catálogo Havoline MotoClub"
    >
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100"
      >
        <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12">
          <h1 class="title-catalogue" style="text-align: left">
            TENEMOS PRODUCTOS <br> INNCREÍBLES PARA TÍ
          </h1>
          <h5 class="subtitle-catalogue " style="text-align: left">
            Usa los puntos otorgados por tu distribuidor
          </h5>
          <h5 class="subtitle-catalogue" style="text-align: left">
            para redimir increíbles accesorios.
          </h5>
        </div>
      </div>
    </div>
    <div class="content-img" id="content-img-id">
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center"
      >
        <div class="col-12 col-md-10 col-lg-9 col-xl-9 col-sm-12">
          <h2 class="subtitle-img">
            Estos productos podrán ser tuyos si sigues sumando con Havoline MotoCLub.
          </h2>
        </div>
        <div class="col-12 col-md-12 col-lg-8 col-xl-8 col-sm-12">

          <!-- filtros -->
          <div class="col-12 col-md-3 col-lg-3 col-xl-2 col-sm-12 mt-4 pl-md-5 pl-xl-2">
            <select
              class="form-control select-filter"
              name="state"
              id="state"
              v-model="filter"
              v-on:change="$event => listCategory()"
            >
              <option value="0" disabled selected>Seleccione el filtro</option>
              <option value="1">Puntos de mayor a menor</option>
              <option value="2">Puntos de menor a mayor</option>
              <option value="3">Productos agregados recientemente</option>
            </select>
          </div>

          <template v-if="loading.list">
            <div
              class="spinner-border text-danger mt-5"
              style="width: 3rem; height: 3rem;"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </template>

          <!-- Lista de productos para usuarios con rol Puntos de Venta -->
          <template v-else>
            <div class="row">
              <div
                class="pt-4 col-xs-12 col-sm-6 col-md-4 col-xl-2"
                v-for="data in productsPOS.slice((currentPage - 1) * 12, currentPage * 12)" :key="data.id"
              >
                <div
                  class="card border-light card-catalogue1"
                  style=" border-radius: 18px; cursor: pointer; height: 425px"
                >
                  <div class="contenedor">
                    <img
                      style="height:240px; mix-blend-mode:multiply; max-width:100%; padding:15px;"
                      :src="data.img"
                      :title="data.name"
                      :alt="data.name"
                      class="mt-2 img-prod"
                      @click="addDetails(data)"
                    />
                    <div>
                      <h4
                        v-if="data.type_catalogue == 4"
                        @click="addDetails(data)"
                        class="centrado font-weight-bold"
                      >
                        {{ data.availability > 0 ? "Unidades disponibles: " + data.availability : "Agotado" }}
                      </h4>
                    </div>
                  </div>
                  <div class="card-body card-body-product pt-0 pt-0">
                    <h5 v-if="data.type_catalogue == 4 && data.points_discount == null" @click="addDetails(data)">
                      <span class="badge badge-pill badge-danger">
                        Puntos: {{ data.points }}
                      </span>
                    </h5>

                    <h5 v-else @click="addDetails(data)">
                      <span class="badge badge-pill badge-danger">
                        <del>Puntos: {{ data.points }}</del>
                      </span><br>
                      <span class="badge badge-pill badge-success">
                        {{ '-' + data.discount }}
                      </span>
                      <span class="badge badge-pill badge-danger">
                        Puntos: {{ data.points_discount }}
                      </span>
                    </h5>

                    <h6 @click="addDetails(data)" class="card-title-img-c">
                      {{ data.name }}
                    </h6>

                    <p class="text-danger pr-2" style="margin-bottom: 0px;">
                      <strong>Tallas disponibles:</strong>
                    </p>
                    <v-btn-toggle class="select-sizes" color="#dc3545">
                      <template v-for="(size, i) in data.product_size">
                        <v-btn v-if="data.type_catalogue == 4 && size.type_size == 0" @click="currentSize = size" small :key="i">
                          <strong>
                            <span>{{ size.sizes.name }}</span>
                          </strong>
                        </v-btn>
                      </template>
                    </v-btn-toggle>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- Paginación -->
          <div style="margin:25px 5px 5px 5px;" class="d-flex justify-content-center">
            <nav aria-label="Page navigation example">
              <ul class="pagination">
                <li class="page-item" :class="{disabled: currentPage === 1}">
                  <a style="color:#0056b3;" class="previous page-link" href="#" @click.prevent="prevPage()">
                    <
                  </a>
                </li>
                <li class="page-item" v-for="page in pages" :key="page" :class="{active: currentPage === page}">
                  <a style="color:#0056b3;" class="page-link" href="#" @click.prevent="changePage(page)">
                    {{ page }}
                  </a>
                </li>
                <li class="page-item" :class="{disabled: currentPage === totalPages}">
                  <a style="color:#0056b3;" class="next page-link" href="#" @click.prevent="nextPage()">
                    >
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <template>
      <div class="popup" v-if="showPopup">
        <div class="contenido_popup_lub">
          <div class="button_close">
            <img
              src="../../../assets/popUpCatalogo/icon_close.png"
              width="22"
              title="cerrar popup"
              alt="cerrar popup"
              @click="closePopup()"
            />
          </div>
          <div class="content_logo_havoline">
            <img
              src="../../../assets/popUpCatalogo/logo_havoline.png"
              width="200"
              title="logo havoline"
              alt="logo havoline"
            />
          </div>
          <div class="content_text_popup">
            <h1 class="text_renovacion">Renovación en progreso</h1>
            <span class="hey_lubricador">¡Hey lubricador! </span><span class="estamos_agregando">estamos agregando a nuestro catálogo</span><br>
            <span class="los_accesorios">los accesorios perfectos para cubrirte en cada aventura</span>
            <br><br>
            <div class="white_line"></div>
            <br>
            <span class="esperalos">¡Espéralos pronto!</span>
            
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import $ from "jquery";

export default {
  data() {
    return {
      filter: 3,
      info: {},
      page: 1,
      loading: {
        list: false,
        btn: false,
      },
      currentSize: [],
      quantity: 1,
      rol: null,
      type_catalogue: null,
      flagUser: null,
      items: [],
      productsPOS: [],

      // Paginación
      currentPage: 1,
      pageSize: 12,
      totalDatos: 0,
      totalPages: 0,
      paginatedData: [],
      paginationVisible: true,

      showPopup: false,
      windowTop: 0,
    };
  },
  computed: {
    pages(){
      const pages = [];
      const limit = this.totalPages > 5 ? 5 : this.totalPages;
      let start = this.currentPage - 2;
      if (start <= 0) start = 1;
      let end = start + limit - 1;
      if (end > this.totalPages) {
        end = this.totalPages;
        start = end - limit + 1;
        if (start <= 0) start = 1;
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    onScroll(){
      this.windowTop = window.top.scrollY;
      sessionStorage.setItem("scroll", JSON.stringify({
        y: this.windowTop,
      }));
    },
    listCategory() {
      this.loading.list = true;
      this.items = [];
      this.productsPOS = [];
      axios
        .post("api/commerce/won/get/products/", {
          type: [8],
        })
        .then((res) => {
          if (res.data.cod == 0) {
            this.items = res.data.data;
            console.log(JSON.stringify(this.items));
            this.items.forEach(element => {
              if(element.type_catalogue == 4 && element.points > 0 && element.availability > 0){
                this.productsPOS.push(element);
              }
            });

            if(this.filter == 1){
              this.totalDatos = this.productsPOS.length;
              this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
              this.productsPOS.sort((a, b) => b.points - a.points);
              this.paginated();
            }
            else if(this.filter == 2){
              this.totalDatos = this.productsPOS.length;
              this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
              this.productsPOS.sort((a, b) => a.points - b.points);
              this.paginated();
            }
            else if(this.filter == 3){
              this.totalDatos = this.productsPOS.length;
              this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
              this.productsPOS.sort((a, b) => {
                const dateA = new Date(a.updated_at);
                const dateB = new Date(b.updated_at);
                return dateB.getTime() - dateA.getTime();
              });
              this.paginated();
            }
          }
          this.loading.list = false;
          setTimeout(() => {
            var scroll = JSON.parse(sessionStorage.getItem("scroll"));
            if (scroll.y > 0) {
              window.scrollTo({
                top: scroll.y
              });
            }
          }, 0);
        })
        .catch((error) => {
          this.loading.list = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },

    // Paginación
    paginated() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.paginatedData = this.productsPOS.slice(start, end);
    },
    changePage(page) {
      this.currentPage = page;
      this.paginated();
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.paginated();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.paginated();
      }
    },
    changeSize(size) {
      this.pageSize = size;
      this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
      this.currentPage = 1;
      this.paginated();
    },
    // Fin paginación

    minusQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
        this.errors.quantity = false;
      }
    },
    addqQuantity() {
      if (this.quantity < 10) {
        this.quantity++;
        this.numberPhone.push({ number: null });
        this.errors.quantity = false;
      } else {
        this.errors.quantity = "No puedes agregar más de 10 productos.";
      }
    },
    addCard() {
      // console.log(this.info);
      var data = {
        productId: this.info.id,
        quantity: this.quantity,
        wonCategory: 0,
        won: false,
      };

      var data1 = {
        quantity: this.quantity,
        item: this.info,
      };
      this.loading.btn = true;
      // console.log(data);
      axios
        .post("superAdmin/commerce/shoppingCart", data)
        .then((res) => {
          if (res.data.cod == 0) {
            var app = this;
            this.$store.commit("addCard", data1);
            $("#exampleModal").modal("hide");
            this.$swal({
              title: "Agregado exitosamente al carrito de compras",
              text: "Gracias por participar.",
              icon: "success",
              showCancelButton: true,
              cancelButtonText: "Seguir comprando",
              confirmButtonColor: "#dc3545",
              cancelButtonColor: "#1da5df",
              confirmButtonText: "Carrito de compras",
            }).then((result) => {
              if (result.value) {
                app.irCarrito();
              }
            });
          }
          this.loading.btn = false;
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            $("#exampleModal").modal("hide");
            this.$router.push({
              name: "login2",
              params: { option: "digitales" },
            });
          }
          this.loading.btn = false;
        });
    },
    addDetails(data) {
      var token = sessionStorage.getItem("token");
      if (token) {
        this.$router.push({
          name: "catalogueDetailsM2",
          params: { id: data.id, ruta: this.$route.path },
        });
      } else {
        this.$router.push({
          name: "catalogueDetailsM",
          params: { id: data.id, ruta: this.$route.path },
        });
      }
    },
    irCarrito() {
      this.$router.push({ name: "userCard" });
    },
    openModal(data) {
      this.info = data;
    },
    getUserSesion(){
      var app = this;
      app.flagUser = localStorage.getItem('flagUser');
      if(app.flagUser == 0){
        localStorage.setItem('flagRedimir', 0);
      } else {
        localStorage.setItem('flagRedimir', 1);
      }
    },
    closePopup() {
      this.showPopup = false;
    },
  },
  props: ["role"],
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll)
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    const url = window.location.href;
    const myArray = url.split("/");
    if(myArray[5] == 'catalogo'){
      localStorage.setItem('flagUser', 1);
    }else{
      localStorage.setItem('flagUser', 0);
    }
    this.getUserSesion();
    this.listCategory();
    // setTimeout(() => {
    //   this.showPopup = true;
    // }, 1000);
  },
};
</script>

<style scoped>
.select-sizes{
  display: grid;
  justify-content: center;
  align-items: center;
  grid-gap: 5px;
  grid-template-columns: repeat(4, auto);
}
.select-sizes .v-btn--active {
  background-color: #dc3545 !important;
  color: #fff !important;
}
.v-btn:not(.v-btn--round).v-size--small {
  height: 28px;
  min-width: auto;
  padding: 0 8px;
}
body {
  padding-right: 0px !important;
}
.t-sizes {
  border-collapse: separate !important;
  border-spacing: 5px;
}
.c-sizes {
  /* background-color: #dc3545; */
  border: 1px solid;
  padding: 1px 5px 1px 5px;
  border-color: #b4b2b2;
  color: #000;
  font-weight: bold;
  font-style: italic;
}
#content-catalogue-id {
  padding-left: 5%;
  padding-top: 14%;
  padding-bottom: 10%;
  height: 500px;
}
.content-catalogue {
  background-size: cover;
  background-image: url("../../../assets/img/BANNER-CATALOGO.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.card-catalogue {
  height: 375px;
}
#content-img-id {
  padding-top: 2%;
  padding-bottom: 2%;
}
.content-img {
  background-color: #eaeaea;
}
.img-prod:hover {
  opacity: 0.5;
}
.contenedor:hover {
  color: #2c2b2b;
  display: block;
}
/*img-prod*/
.centrado:hover {
  background-color: rgb(255, 255, 255, 0.6);
}
.contenedor {
  color: transparent;
  position: relative;
  display: inline-block;
}
.centrado {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.title-catalogue {
  font-size: 55px;
  font-family: "Gotham-UltraItalic", sans-serif;
}
.subtitle-catalogue {
  font-family: "GothamBookItalic", sans-serif;
  font-size: 25px;
}
.subtitle-catalogue1 {
  font-family: "GothamBoldItalic", sans-serif;
  font-size: 25px;
}
.subtitle-img {
  color: #dc3545;
  font-size: 23px;
  font-family: "GothamBoldItalic", sans-serif;
}
.description {
  text-align: left;
  color: #756c6c;
  font-family: "GothamBoldItalic", sans-serif;
}
.description2 {
  text-align: left;
  color: #756c6c;
  font-family: "GothamBookItalic", sans-serif;
}
.subtitle-img-modal {
  color: #dc3545;
  font-size: 25px;
  font-family: "GothamBoldItalic", sans-serif;
  padding-bottom: 3%;
  text-align: left;
}
.btn-close {
  font-size: 35px;
  font-weight: normal;
}
.modal-prod {
  padding: 0.5rem 1rem 0rem 1rem;
}
.card-title-img-c {
  color: black;
  font-size: 13px;
  padding-bottom: 10px;
}
.card-catalogue:hover {
  background-color: #f8f9fa;
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.padre {
  text-align: center;
}
.hijo {
  padding: 10px;
  margin: 10px;
  display: inline-block;
}
.page-item.active .page-link {
  border-style: none;
  border-radius: 20px;
  background-color: #dc3545;
}
a.page-link {
  color: black;
  cursor: pointer;
}
a.page-link:hover {
  color: #dc3545;
}
.page-link {
  background-color: #f5f5dc00;
  border-radius: 20px;
  border-color: none;
}
.page-item.disabled .page-link {
  color: #dc3545;
  background-color: #fff0;
  border-color: #dee2e600;
}
.text-p {
  color: #756c6c;
}
.center-paginate {
  padding-left: 15%;
}
.card-body-product {
  height: 95px;
}
.ul-pagination {
  padding: 0px;
}

/* POPUP DE RENOVACIÓN DE CATÁLOGO */
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.contenido_popup_lub {
  max-width: 90%;
  background-image: url('../../../assets/popUpCatalogo/fondo_lubricador.jpg');
  background-size: cover;
  background-position: center;
  padding: 20px;
  border-radius: 5px;
}
.button_close{
  float: right;
  margin: -33px -30px 0px 0px;
  cursor: pointer;
}
.content_logo_havoline {
  padding: 10px;
  margin: -20px;
}
.content_text_popup{
  padding: 20px;
  margin-top: 15px;
}
.text_renovacion{
  font-family: 'politica-black', sans-serif;
  color: #ffcf00;
  font-weight: bold;
}
.hey_lubricador{
  font-family: 'politica-black', sans-serif;
  color:#ffce00;
  font-size:28px;
  font-weight:bold;
}
.estamos_agregando,
.los_accesorios,
.esperalos{
  font-family: 'politica-black', sans-serif;
  font-size:28px;
  font-weight:bold;
}
.white_line{
  background-image: url('../../../assets/popUpCatalogo/linea_white.jpg ');
  background-size: cover;
  background-position: center;
  padding: 1px 0px 1px 0px;
}
.badge-success{
  font-size: 20px;
  margin: 2px 1px;
}

@media (max-width: 880px) {
  .text_renovacion {
    font-size: 35px !important;
  }
  .hey_lubricador, .estamos_agregando, .los_accesorios, .esperalos {
    font-size: 24px !important;
  }
}

@media (max-width: 780px) {
  .content_logo_havoline {
    padding-top: 5px;
  }
  .content_logo_havoline > img{
    width: 150px;
  }
  .text_renovacion {
    font-size: 30px !important;
  }
  .hey_lubricador, .estamos_agregando, .los_accesorios, .esperalos {
    font-size: 20px !important;
  }
}

@media (max-width: 480px) {
  .content_text_popup {
    padding: 20px 0px 20px 0px;
  }
  .text_renovacion {
    font-size: 28px !important;
  }
  .hey_lubricador, .estamos_agregando, .los_accesorios, .esperalos {
    font-size: 18px !important;
  }
}

@font-face {
  font-family: "politica-black";
  src: url("./../../../assets/font/politica-black.otf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP XL */
@media (min-width: 2560px) {
  .card-catalogue {
    height: 450px;
  }
}

/* LAPTOP L */
@media (min-width: 1440px) {
  .card-catalogue {
    height: 400px;
  }
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
}

/* TABLET */
@media (max-width: 1023px) {
  .card-catalogue {
    height: 360px;
  }
  .subtitle-img {
    padding-top: 10px;
  }
  .select-filter {
    padding: 0px 30px;
  }
}

/* MOBILE L */
@media (max-width: 767px) {
  .card-catalogue {
    height: 460px;
  }
  #content-catalogue-id {
    height: 600px;
  }
  .center-paginate {
    padding-left: 25%;
  }
  .title-catalogue {
    font-size: 40px;
    font-family: "Gotham-UltraItalic", sans-serif;
  }
  .subtitle-catalogue {
    font-family: "GothamBookItalic", sans-serif;
    font-size: 20px;
  }
  .subtitle-img {
    font-size: 20px;
  }
  .select-filter {
    padding: 0px 30px;
  }
}

/* MOBILE M */
@media (max-width: 375px) {
  .card-catalogue {
    height: 440px;
  }
  #content-catalogue-id {
    height: 600px;
  }
  .center-paginate {
    padding-left: 27%;
  }
  .select-filter {
    padding: 0px 30px;
  }
}

/* MOBILE S */
@media (max-width: 320px) {
  .card-catalogue {
    height: 385px;
  }
  #content-catalogue-id {
    height: 600px;
  }
  .center-paginate {
    padding-left: 19%;
  }
  .select-filter {
    padding: 0px 30px;
  }
}
</style>
